import { render, staticRenderFns } from "./profileCard.vue?vue&type=template&id=7fc0f3b8&"
import script from "./profileCard.vue?vue&type=script&lang=js&"
export * from "./profileCard.vue?vue&type=script&lang=js&"
import style0 from "./profileCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports